/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import { useEffect, useState } from "react";

import {
	ICountryBrandApplicationContext,
	useCountryBrandApplicationContext,
} from "../../contexts/CountryBrandApplicationContextProvider";
import { UIEvents } from "../../UIEvents";

const DOCUMENT_TYPE_VALIDATION = {
	CI: {
		pattern: "[0-9]+",
		title: "No incluir ni puntos ni guion",
	},
	DNI: {},
	Passport: {},
	Other: {},
};

function LegalRepresentative() {
	const [legalRepresentativeDocumentType, setLegalRepresentativeDocumentType] = useState("CI");
	const { currentStep, formRef, countryBrandApplication, update, setPreviousStep } =
		useCountryBrandApplicationContext() as ICountryBrandApplicationContext;

	const {
		legalRepresentativeName,
		legalRepresentativeDocumentNumber,
		legalRepresentativeDocumentTypeOtherName,
	} = countryBrandApplication;

	useEffect(() => {
		if (countryBrandApplication.legalRepresentativeDocumentType) {
			setLegalRepresentativeDocumentType(countryBrandApplication.legalRepresentativeDocumentType);
		}
	}, [countryBrandApplication]);

	useEffect(() => {
		setPreviousStep(currentStep - 1);
		function submitStepData() {
			const formElement = formRef.current as HTMLFormElement;
			const legalRepresentativeName = formElement.elements.legalRepresentativeName.value;
			const legalRepresentativeDocumentType =
				formElement.elements.legalRepresentativeDocumentType.value;
			const legalRepresentativeDocumentTypeOtherName =
				formElement.elements.legalRepresentativeDocumentTypeOtherName?.value ?? "";
			const legalRepresentativeDocumentNumber =
				formElement.elements.legalRepresentativeDocumentNumber.value;

			update({
				data: {
					legalRepresentativeName,
					legalRepresentativeDocumentType,
					legalRepresentativeDocumentTypeOtherName,
					legalRepresentativeDocumentNumber,
				},
				nextStep: currentStep + 1,
			});
		}

		document.addEventListener(UIEvents.builtInFormValidateSucess, submitStepData);

		return () => {
			document.removeEventListener(UIEvents.builtInFormValidateSucess, submitStepData);
		};
	}, []);

	function handleOnChangeLegalRepresentativeDocumentType(
		event: React.ChangeEvent<HTMLSelectElement>
	) {
		setLegalRepresentativeDocumentType(event.target.value);
	}

	return (
		<div className="step-page" id="step-3">
			<section>
				<h3>3 - Representante legal</h3>
				<label htmlFor="legalRepresentativeName">
					<p>Nombre *</p>
					<input
						type="text"
						name="legalRepresentativeName"
						id="legalRepresentativeName"
						required
						defaultValue={legalRepresentativeName}
					/>
				</label>
				<label htmlFor="legalRepresentativeDocumentType">
					<p>Tipo de documento</p>
					<select
						name="legalRepresentativeDocumentType"
						id="legalRepresentativeDocumentType"
						value={legalRepresentativeDocumentType}
						onChange={handleOnChangeLegalRepresentativeDocumentType}
					>
						<option value="CI">CI</option>
						<option value="DNI">DNI</option>
						<option value="Passport">Pasaporte</option>
						<option value="Other">Otro</option>
					</select>
					{legalRepresentativeDocumentType === "Other" && (
						<input
							type="text"
							name="legalRepresentativeDocumentTypeOtherName"
							id="legalRepresentativeDocumentTypeOtherName"
							placeholder="Indique el tipo"
							defaultValue={legalRepresentativeDocumentTypeOtherName}
							required
						/>
					)}
				</label>
				<label htmlFor="legalRepresentativeDocumentNumber">
					<p>Numero de documento *</p>
					<input
						type="text"
						name="legalRepresentativeDocumentNumber"
						id="legalRepresentativeDocumentNumber"
						required
						defaultValue={legalRepresentativeDocumentNumber}
						{...DOCUMENT_TYPE_VALIDATION[legalRepresentativeDocumentType]}
					/>
					{legalRepresentativeDocumentType === "CI" && (
						<span className="span-message">No incluir ni puntos ni guion</span>
					)}
				</label>
			</section>
		</div>
	);
}

export { LegalRepresentative };
